import axios from 'axios';
import { getConfigVariable } from '../fn/Config';
import { sessionId } from '../recoil/atom/SessionId';

/**
 * Configure Axios service with base URL and headers
 */
const API_URI = getConfigVariable('API_URI');
// If query param is set, use it, otherwise use the config (which is what the recoil state atom is based on)
const API_VERSION = window.apiversion ? window.apiversion : getConfigVariable('API_VERSION');
const VERSION = '00';
const PARENT_ID = '0000000000000000';
const TRACE_FLAGS = '00';
const TRACE_ID =
  window.TRACE_ID === '%TRACE-ID%'
    ? '00000000000000000000000000000000'
    : `${window.TRACE_ID}`.replace(/-/gi, '');

const TRACEPARENT_STRING = `${VERSION}-${TRACE_ID}-${PARENT_ID}-${TRACE_FLAGS}`;

/**
 * Create Axios instance with default configuration
 * Includes sessionId and API version in headers for tracking and versioning
 */
const AxiosService = axios.create({
  baseURL: `${API_URI}`,
  headers: {
    traceparent: TRACEPARENT_STRING,
    'app-session-id': sessionId,
    'app-api-version': API_VERSION,
  },
});

export default AxiosService;
